var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"no-data__container"},[_c('svg-icon',{attrs:{"width":"5rem","height":"5rem","color":"disabled","name":"far-empty-set"}}),_c('div',{staticClass:"no-data__text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }